<template>
	<div>
		<!-- <mainHead :title="mainHeadTitle" @btnClick="addTableData" :hasPermiDict="hasPermiDict"></mainHead> -->
		<div class="mianPage">
			<div class="topSearch">
				<el-form inline class="el-form flex_start">
					<el-form-item>
						<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange"
							range-separator="～" start-placeholder="开始日期" end-placeholder="结束日期" size="small" :clearable="false">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.platformId" filterable clearable size="small" style="width:210px"
							placeholder="广告网络">
							<el-option v-for="item in networkOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<!-- <el-input clearable v-model="queryData.name" size="small" style="width:210px" placeholder="请输入"></el-input> -->
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.apiStatus" clearable size="small" style="width:210px" placeholder="报表API状态">
							<el-option label="未开通" :value="0"></el-option>
							<el-option label="已开通" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<div class="menu-right">
						<el-button @click="searchReset" size="small" v-hasPermi="['aggregation:ADNetwork:query']">重置</el-button>
						<el-button type="primary" @click="confirmQuery" size="small"
							v-hasPermi="['aggregation:ADNetwork:query']">查询</el-button>
					</div>
				</el-form>
			</div>
			<!-- table表格 -->
			<div class="tableBox">
				<div class="tableTopBtn space_between">
					<el-button type="primary" size="small" @click="addTableData" v-hasPermi="['aggregation:ADNetwork:add']">
						<i class="el-icon-plus"></i> 新增广告网络
					</el-button>
					<div class="tableBtns flex_start">
						<el-button @click="editTheadDialog" size="small"><i class="el-icon-setting"></i>
							自定义指标</el-button>
						<div @click="networkExport" class="exportBtn flex_center" v-hasPermi="['aggregation:ADNetwork:export']">
							<img src="../../assets/icon/export.png" alt="" />
							<div>导出</div>
						</div>
					</div>
				</div>
				<el-table :max-height="600" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
					class="el_table" @sort-change="sortChangeFun" :header-cell-class-name="handleHeadAddClass">
					<!-- <el-table-column prop="name" label="日期"></el-table-column> -->
					<el-table-column prop="" label="广告网络"  min-width="120">
						<template slot-scope="scope">
							<div class="selectTemp flex_start" v-if="scope.row.platformName">
								<img :src="scope.row.platformIcon" alt="" />
								<div style="font-size: 12px;">{{scope.row.platformName}}</div>
							</div>
							<div v-else> 合计 </div>
						</template>
					</el-table-column>
					<el-table-column prop="account" label="账号名称" min-width="120"></el-table-column>
					<el-table-column prop="reqNum" label="报表API状态" min-width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.apiStatus == 1">已开通</div>
							<div v-else-if="scope.row.apiStatus == 0"> 未开通 </div>
							<div v-else> - </div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="操作">
						<template slot-scope="scope">
							<el-button type="text" size="small" v-hasPermi="['aggregation:ADNetwork:edit']"
								@click="editTable(scope.row)" v-if="scope.row.id">编辑</el-button>
						</template>
					</el-table-column>
					<template v-for="(columnObj,index) in tHeadCheckedList">
						<!-- <el-table-column v-if="columnObj.prop == 'showNum'" :prop="columnObj.prop" label="广告展示量"
							align="right" :width="columnObj.width" :fixed="columnObj.fixed"
							:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
						</el-table-column> -->
						<!-- v-else -->
						<el-table-column :prop="columnObj.prop" :label="columnObj.label"
							align="right" :width="columnObj.width" :fixed="columnObj.fixed"
							:sortable="columnObj.sortable?'custom':false" :key="index" :min-width="columnObj.minWidth">
							<template v-slot="scope">
								<slot :name="columnObj.prop" :scope="scope">
									<div v-if="scope.row[columnObj.prop] !== null">{{scope.row[columnObj.prop]}}</div>
									<div v-else>-</div>
								</slot>
							</template>
						</el-table-column>
					</template>
					<!-- <el-table-column prop="income" label="API收益(¥)" align="right" sortable="custom" min-width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.income !== null">{{scope.row.income}}</div>
							<div v-else> - </div>
						</template>
					</el-table-column>
					<el-table-column prop="reqNum" label="API请求量" align="right" sortable="custom" min-width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.reqNum !== null">{{scope.row.reqNum}}</div>
							<div v-else> - </div>
						</template>
					</el-table-column>
					<el-table-column prop="fillNum" label="API返回量" align="right" sortable="custom" min-width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.fillNum !== null">{{scope.row.fillNum}}</div>
							<div v-else> - </div>
						</template>
					</el-table-column>
					<el-table-column prop="apiFillRate" label="API填充率" align="right" sortable="custom" min-width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.apiFillRate !== null">{{scope.row.apiFillRate}}</div>
							<div v-else> - </div>
						</template>
					</el-table-column>
					<el-table-column prop="showNum" label="API展示量" align="right" sortable="custom" min-width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.showNum !== null">{{scope.row.showNum}}</div>
							<div v-else> - </div>
						</template>
					</el-table-column>
					<el-table-column prop="clickNum" label="API点击量" align="right" sortable="custom" min-width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.clickNum !== null">{{scope.row.clickNum}}</div>
							<div v-else> - </div>
						</template>
					</el-table-column>
					<el-table-column prop="apiClickRate" label="API点击率" align="right" sortable="custom" min-width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.apiClickRate !== null">{{scope.row.apiClickRate}}</div>
							<div v-else> - </div>
						</template>
					</el-table-column>
					<el-table-column prop="ecpm" label="API eCPM(¥)" align="right" sortable="custom" min-width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.ecpm !== null">{{scope.row.ecpm}}</div>
							<div v-else> - </div>
						</template>
					</el-table-column> -->
					<el-table-column prop="" label="同步" align="center" min-width="110" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" size="small" v-hasPermi="['aggregation:ADNetwork:edit']"
							@click="asyncTable(scope.row)" v-if="scope.row.id" :disabled="scope.row.apiStatus == 0">
								<i class="el-icon-refresh" style="margin-right: 2px;"></i> 同步报表
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :title="networkDialogTitle" :visible.sync="dialogVisible" width="28%">
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="dynamicRules" :model="networkFormData"
				ref="ruleForm">
				<el-form-item label="广告网络：" prop="platformId">
					<el-select v-model="networkSelectForm" clearable @change="networkSeleteChange" size="small" value-key="value">
						<el-option v-for="item in networkOptions" :key="item.value" :label="item.label" :value="item">
							<div class="selectTemp flex_start">
								<img :src="item.icon" alt="" />
								<div>{{item.label}}</div>
							</div>
						</el-option>
						<template #prefix>
							<div class="checkedTemp flex_start" v-if="networkSelectForm.icon">
								<img :src="networkSelectForm.icon" alt="" />
							</div>
						</template>
					</el-select>
				</el-form-item>
				<el-form-item label="账号名称：" prop="account">
					<el-input clearable size="small" placeholder="请输入" v-model="networkFormData.account"></el-input>
				</el-form-item>
				<el-form-item label="报表API状态：" prop="apiStatus">
					<el-radio v-model="networkFormData.apiStatus" :label="0">未开通</el-radio>
					<el-radio v-model="networkFormData.apiStatus" :label="1">已开通</el-radio>
				</el-form-item>
				<el-form-item label="AppKey：" prop="appKeyStatus">
					<el-radio v-model="networkFormData.appKeyStatus" :label="0">不支持</el-radio>
					<el-radio v-model="networkFormData.appKeyStatus" :label="1">支持</el-radio>
				</el-form-item>
				<template v-if="networkFormData.apiStatus == 1&&networkSelectForm.paramList&&networkSelectForm.paramList.length>0">
					<el-form-item :label="`${item.key}：`" :prop="item.value" required
						v-for="(item,index) in networkSelectForm.paramList" :key="index">
						<el-input clearable size="small" placeholder="请输入" :value="networkFormData[item.value]"
							@input="handleInput(item.value, $event)"></el-input>
					</el-form-item>
					<!-- <el-form-item label="Secret Key：" prop="secretKey">
						<el-input clearable size="small" placeholder="请输入" v-model="networkFormData.secretKey"></el-input>
					</el-form-item> -->
				</template>
				<div class="card-bottom flex_end">
					<el-button @click="closeDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmDialog('ruleForm')" size="medium">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
		<el-dialog title="自定义指标" :visible.sync="tHeadDialogVisible" width="40%">
			<div class="tHeadEditBox space_between">
				<div class="tHeadAllList">
					<el-collapse v-model="activeNames">
						<el-collapse-item :title="item.name" :name="index" v-for="(item,index) in tHeadAllList" :key="index">
							<div class="checkList">
								<el-checkbox :indeterminate="item.isIndeterminate" v-model="item.groupChecked" class="el_check_box"
									@change="handleGroupCheckChange($event,item,index)" style="width: 100%;">全选</el-checkbox>
								<el-checkbox v-for="(items,indexs) in item.list" :key="indexs" size="medium"
									@change="checkChange($event,index,items,indexs)" v-model="items.checked" class="el_check_box">
									{{items.label}}
								</el-checkbox>
							</div>
						</el-collapse-item>
					</el-collapse>
				</div>
				<div class="tHeadCheckShowBox">
					<div class="tHeadCheckShowTitle">已选指标</div>
					<div class="tHeadCheckShowTips">上下拖动可调整排序</div>
					<div class="tHeadCheckShowList" v-show="tHeadCheckShowList.length>0">
						<div class="tHeadCheckedOne flex_start" v-for="(item,index) in tHeadCheckShowList" :key="index"
							@dragstart="handleDragStart($event, item)" @dragover.prevent="handleDragOver($event, item)"
							@dragenter="handleDragEnter($event, item)" @dragend="handleDragEnd($event, item)" :draggable="true">
							<!-- <i class="el-icon-notebook-2"></i> -->
							<img src="../../assets/icon/sort.png" alt="" />
							<div>{{item.label}}</div>
							<i class="el-icon-close" style="margin-left: auto;" @click.stop="deleteTHeadChecked(item,index)"></i>
						</div>
					</div>
					<el-empty description="暂无数据" v-show="tHeadCheckShowList.length<=0"></el-empty>
				</div>
			</div>
			<div class="card-bottom flex_end" style="margin-top: 30px;">
				<el-button @click="closeTHeadDialog" size="medium">取消</el-button>
				<el-button type="primary" @click="confirmTHeadDialog()" size="medium">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="syncReportDateDialogVisible" width="30%">
			<div>{{ syncReportDateDialogText }}</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" size="small" @click="syncReportDateDialogVisible = false">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				queryData: {}, //列表查询条件
				companyOptions: [], // 公司下拉选择列表
				tableData: [],
				datePicker: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				syncReportDateDialogVisible: false, // 同步报表日期跨度提示弹窗是否显示
				syncReportDateDialogText: '同步报表最大日期跨度不能超过一天，请重新选择', // 同步报表日期跨度提示文案

				dialogVisible: false,
				networkOptions: [
					// {label: 'Sigmob',value: 'Sigmob',icon: require('../../assets/adsNetwork/Sigmob.png')}
				],
				rulesApi: {
					platformId: [{
						required: true,
						message: '请选择广告网络',
						trigger: 'blur'
					}],
					account: [{
						required: true,
						message: '请输入账号名称',
						trigger: 'blur'
					}],
					// publicKey: [{
					// 	required: true,
					// 	message: '请输入',
					// 	trigger: 'blur'
					// }],
					// secretKey: [{
					// 	required: true,
					// 	message: '请输入',
					// 	trigger: 'blur'
					// }],
				},
				networkFormData: {
					apiStatus: 0,
					appKeyStatus: 0, // AppKey支持状态，0：不支持，1：支持
					platformId: '',
					account: ''
				},
				networkDialogTitle: '新增广告网络',
				networkSelectForm: {},

				// 表格排序数据
				sortField: {},
				orderBys: [],
				
				
				tHeadDialogVisible: false,
				activeNames: [0, 1, 2],
				tHeadAllList: [{
						name: '统计指标',
						groupChecked: false,
						isIndeterminate: false,
						list: [
							{
								prop: 'channelEstimateProfit',
								label: "总收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'mediaEstimateProfit',
								label: "媒体收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120',
								temp: true,
							},
							{
								prop: 'divideEstimateProfit',
								label: "分成收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'profitGapRate',
								label: "收益GAP",
								checked: false,
								sortable: false,
								minWidth: '120'
							},
							{
								prop: 'mediaReqNum',
								label: "流量请求量",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'mediaReqSuccNum',
								label: "流量返回量",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'succReqRate',
								label: "流量填充率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'mediaShowNum',
								label: "流量展示量",
								checked: false,
								sortable: true,
								minWidth: '120',
								temp: true,
							},
							{
								prop: 'succShowRate',
								label: "流量展示率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'mediaClickNum',
								label: "流量点击量(去重)",
								checked: false,
								sortable: true,
								minWidth: '140'
							},
							{
								prop: 'mediaDeductClickNum',
								label: "流量点击量(扣量后)",
								checked: false,
								sortable: true,
								minWidth: '150',
								temp: true,
							},
							{
								prop: 'uniqueClickRate',
								label: "流量点击率(去重)",
								checked: false,
								sortable: true,
								minWidth: '150',
							},
							{
								prop: 'deductClickRate',
								label: "流量点击率(扣量后)",
								checked: false,
								sortable: true,
								minWidth: '150',
							},
							{
								prop: 'channelEcpm',
								label: "总收益eCPM(¥)",
								checked: false,
								sortable: true,
								minWidth: '140',
							},
							{
								prop: 'mediaEcpm',
								label: "媒体收益eCPM(¥)",
								checked: false,
								sortable: true,
								minWidth: '140'
							}
						]
					},
					{
						name: 'API指标',
						groupChecked: false,
						isIndeterminate: false,
						list: [
							{
								prop: 'income',
								label: "API收益(¥)",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'reqNum',
								label: "API请求量",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'fillNum',
								label: "API返回量",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'apiFillRate',
								label: "API填充率",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'showNum',
								label: "API展示量",
								checked: false,
								sortable: true,
								minWidth: '120'
							},
							{
								prop: 'clickNum',
								label: "API点击量",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'apiClickRate',
								label: "API点击率",
								checked: false,
								sortable: true,
								minWidth: '120',
							},
							{
								prop: 'ecpm',
								label: "API eCPM(¥)",
								checked: false,
								sortable: true,
								minWidth: '120',
							}
						]
					}
				],
				tHeadCheckShowList: [], // 表头选中临时展示列表
				tHeadCheckedList: [], //最终选中的表头展示数组
				// 默认展示的表头
				tHeadNormalCheckedList: [],
				dragging: null,
			}
		},
		computed: {
			dynamicRules() {
				const rules = {
					platformId: [{required: true,message: '请选择广告网络',trigger: 'blur'}],
					account: [{required: true,message: '请输入账号名称',trigger: 'blur'}],
				}
				if(this.networkFormData.apiStatus == 1 && this.networkSelectForm.paramList && this.networkSelectForm.paramList.length>0){
					this.networkSelectForm.paramList.forEach(item => {
						rules[item.value] = [{
							required: true,
							message: `请输入${item.key}`,
							trigger: ['blur', 'change']
						}]
					})
					return rules
				}else{
					return rules
				}
			}
		},
		mounted() {
			this.dateInit();
			this.getCompanyOption();
			this.getPlatformOption();
			this.getTableData();
			if (localStorage.getItem('sdk-adNetworkTHead')) {
				this.tHeadCheckedList = JSON.parse(localStorage.getItem('sdk-adNetworkTHead'))
			}else{
				this.tHeadAllList.forEach((category, categoryIndex) => {
					const foundItem = category.list.forEach(items => {
						this.$set(items, 'checked', true);
						this.tHeadNormalCheckedList.push(items);
					});
				});
				this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
			}
			// let arrs = [{key: 'Public Key',value: 'publicKey'},{key: 'Secret Key',value: 'secretKey'}]
			// console.log(JSON.stringify(arrs));
		},
		methods: {
			// 日期选择器初始化
			dateInit() {
			  let endDate = new Date();
			  endDate.setDate(endDate.getDate() - 1);      // 昨天（不包含今天）
			  let startDate = new Date(endDate);           // 基于 endDate 创建副本
			  startDate.setDate(startDate.getDate() - 6);  // 再向前推6天，共7天范围
			  			
			  const formatDate = (date) => {
			      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
			  };
			  this.datePicker = [formatDate(startDate), formatDate(endDate)];
			},
			handleInput(key, value) {
				// 使用 $set 确保响应式
				this.$set(this.networkFormData, key, value)
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
			},
			// 获取渠道下拉选择列表
			async getPlatformOption() {
				let res = await this.$http.get(this.$api.common.platformOption);
				this.networkOptions = res.data
			},
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startDate = this.datePicker[0];
					data.endDate = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				let res = await this.$http.post(this.$api.mediaAd.networkList, data);
				if(res.code == 1){
					this.tableData = res.data.page.list
					this.total = res.data.page.totalRecord
					if (this.tableData.length > 0) {
						let obj = {
							recordTime: '合计',
							account: '-',
							income: res.data.income ? res.data.income : '-',
							reqNum: res.data.reqNum ? res.data.reqNum : '-',
							fillNum: res.data.fillNum ? res.data.fillNum : '-',
							apiFillRate: res.data.apiFillRate,
							showNum: res.data.showNum ? res.data.showNum : '-',
							clickNum: res.data.clickNum ? res.data.clickNum : '-',
							apiClickRate: res.data.apiClickRate,
							ecpm: res.data.ecpm ? res.data.ecpm : '-',
							channelEstimateProfit: res.data.channelEstimateProfit,
							mediaEstimateProfit: res.data.mediaEstimateProfit,
							divideEstimateProfit: res.data.divideEstimateProfit,
							mediaReqNum: res.data.mediaReqNum,
							mediaReqSuccNum: res.data.mediaReqSuccNum,
							succReqRate: res.data.succReqRate,
							mediaShowNum: res.data.mediaShowNum,
							succShowRate: res.data.succShowRate,
							deductClickRate: res.data.deductClickRate,
							mediaClickNum: res.data.mediaClickNum,
							mediaDeductClickNum: res.data.mediaDeductClickNum,
							uniqueClickRate: res.data.uniqueClickRate,
							channelEcpm: res.data.channelEcpm,
							mediaEcpm: res.data.mediaEcpm,
							profitGapRate: res.data.profitGapRate?res.data.profitGapRate:'-'
						}
						this.tableData.unshift(obj)
					}
				}
			},
			// 同步报表
			async asyncTable(row){
				// 日期范围选择多天时，弹出同步报表日期跨度提示并停止请求
				// if (this.datePicker && this.datePicker.length > 1 && this.datePicker[0] !== this.datePicker[1]) {
				// 	this.syncReportDateDialogVisible = true
				// 	return
				// }
				// 同步报表请求参数
				let data = {
					platformNetworkId: row.id
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startTime = this.datePicker[0];
					data.endTime = this.datePicker[1];
				}
				let res = await this.$http.post(this.$api.mediaAd.networkListAsync, data);
				if(res.code == 1){
					this.$message.success('同步成功');
					this.getTableData();
				}
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {
					platformId: '',
					apiStatus: '',
				}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			addTableData() {
				this.networkFormData = {
						apiStatus: 0,
						appKeyStatus: 0, // AppKey支持状态，0：不支持，1：支持
						platformId: '',
						account: ''
					},
					this.networkSelectForm = {}
				this.networkDialogTitle = '新增广告网络'
				this.dialogVisible = true
				this.$nextTick(()=>{
					this.$refs['ruleForm'].resetFields();
				})
			},
			editTable(row) {
				this.networkDialogTitle = '编辑广告网络'
				this.networkFormData = JSON.parse(JSON.stringify(row))
				// 旧数据未配置时默认不支持，保证编辑表单始终有选中项
				this.networkFormData.appKeyStatus = Number(this.networkFormData.appKeyStatus) || 0
				this.networkOptions.forEach((item) => {
					if (item.value === this.networkFormData.platformId) {
						this.networkSelectForm = JSON.parse(JSON.stringify(item))
					}
				})
				this.dialogVisible = true
			},
			networkSeleteChange(e) {
				// console.log(e);
				// this.networkFormData.platformId = e.value
				this.$set(this.networkFormData, 'platformId', e.value)
				this.networkSelectForm = e
				// console.log(this.networkSelectForm)
			},
			closeDialog() {
				this.dialogVisible = false
			},
			confirmDialog(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.networkFormData;
						if (this.datePicker.length > 0) {
							data['startDate'] = this.datePicker[0]
							data['endDate'] = this.datePicker[1]
						}
						let res = await this.$http.post(this.$api.mediaAd.networkSave, data);
						if (res.code == 1) {
							if (data.id) {
								this.$message.success('修改成功');
							} else {
								this.$message.success('新增成功');
							}
						}
						this.closeDialog();
						this.getTableData();
					}
				});
			},
			// 表头高亮保持
			handleHeadAddClass({
				column
			}) {
				// console.log(column)
				if (this.sortField[column.property]) {
					column.order = this.sortField[column.property]
				}
			},
			// 排序监听
			sortChangeFun({
				column,
				prop,
				order
			}) {
				// 触发的排序和缓存的排序相同时，取消该字段的排序
				if (!order || this.sortField[prop] === order) {
					this.sortField[prop] = null
				} else {
					this.sortField[prop] = order
				}
				this.orderBys = []
				let direction = ''
				for (const i in this.sortField) {
					if (this.sortField[i]) {
						if (this.sortField[i] == 'ascending') {
							direction = 'ASC'
						} else if (this.sortField[i] == 'descending') {
							direction = 'DESC'
						}
						this.orderBys.push({
							"orderField": i,
							"orderType": direction
						})
					}
				}
				this.currentPage = 1
				this.queryData['adOrderByReqs'] = this.orderBys
				this.getTableData() //调用后端查询接口
			},
			// 导出
			async networkExport() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize
				}
				if (this.datePicker && this.datePicker.length > 0) {
					data.startDate = this.datePicker[0];
					data.endDate = this.datePicker[1];
				}
				data = {
					...data,
					...this.queryData
				}
				let res = await this.$http.post(this.$api.mediaAd.networkListExport, data, 1);
				const time = this.getTimeFun();
				this.$http.downloads(res, `${time}广告网络.xls`)
			},
			// 下载选择的日期
			getTimeFun() {
				if (!this.datePicker || !this.datePicker.length) {
					return ''
				}
				var startMonth = this.datePicker[0];
				var endMonth = this.datePicker[1];
				// 如果开始时间和结束时间相同，则以开始时间为主
				if (startMonth === endMonth) {
					endMonth = ''
				};
				return startMonth + "-" + endMonth;
			},
			editTheadDialog() {
				this.tHeadDialogVisible = true
				if (localStorage.getItem('sdk-adNetworkTHead')) {
					this.tHeadCheckShowList = JSON.parse(localStorage.getItem('sdk-adNetworkTHead'))
					this.tHeadCheckedList = JSON.parse(localStorage.getItem('sdk-adNetworkTHead'))
				}else{
					this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
					this.tHeadCheckShowList = JSON.parse(JSON.stringify(this.tHeadNormalCheckedList))
				}
				// 初始化分组状态
				this.initGroupStates();
			},
			// 初始化分组状态
			initGroupStates() {
				// 重置所有分组的选中状态
				this.tHeadAllList.forEach((category, categoryIndex) => {
					category.groupChecked = false;
					category.isIndeterminate = false;
				});
				// 遍历选中的列，设置对应的 checked 状态
				this.tHeadCheckShowList.forEach((item) => {
					this.tHeadAllList.forEach((category, categoryIndex) => {
						const foundItem = category.list.find(items => items.label === item.label);
						if (foundItem) {
							this.$set(foundItem, 'checked', true);
						}
					});
				});
				// 更新所有分组的状态
				this.tHeadAllList.forEach((category, categoryIndex) => {
					this.updateGroupState(categoryIndex);
				});
			},
			closeTHeadDialog() {
				this.tHeadDialogVisible = false
			},
			confirmTHeadDialog() {
				if (this.tHeadCheckShowList.length <= 0) {
					this.$message.warning("请选择要展示的指标");
				}
				this.tHeadCheckedList = JSON.parse(JSON.stringify(this.tHeadCheckShowList));
				localStorage.removeItem('sdk-adNetworkTHead');
				localStorage.setItem('sdk-adNetworkTHead', JSON.stringify(this.tHeadCheckedList))
				this.$message.success("保存成功");
				this.closeTHeadDialog();
			},
			// 单个选中
			checkChange(e, index, items, indexs) {
				if (e === true) {
					this.tHeadCheckShowList.push(items)
				} else {
					const idx = this.tHeadCheckShowList.findIndex(item => item.label === items.label);
					if (idx !== -1) {
						this.tHeadCheckShowList.splice(idx, 1);
					}
				}
				// 更新分组状态
				this.updateGroupState(index);
			},
			updateGroupState(groupIndex) {
				const group = this.tHeadAllList[groupIndex];
				if (!group) return;
				const list = group.list;
				const checkedCount = list.filter(item => item.checked).length;
				const totalCount = list.length;
				// 更新全选状态
				group.groupChecked = checkedCount === totalCount;
				// 更新半选状态
				group.isIndeterminate = checkedCount > 0 && checkedCount < totalCount;
			},
			// 分组选中
			handleGroupCheckChange(e, item, index) {
				item.isIndeterminate = false;
				if (e === true) {
					// 将 item.list 下的所有对象 checked 设为 true
					item.list.forEach(listItem => {
						this.$set(listItem, 'checked', true);
					});
					// 去重版本的合并
					const newItems = item.list.filter(newItem =>
						!this.tHeadCheckShowList.some(existingItem => existingItem.label === newItem.label)
					);
					this.tHeadCheckShowList = this.tHeadCheckShowList.concat(newItems);
				} else {
					const labelsToRemove = item.list.map(items => items.label);
					this.tHeadCheckShowList = this.tHeadCheckShowList.filter(item1 => !labelsToRemove.includes(item1.label));
					// 可选：取消分组选中时也将 checked 设为 false
					item.list.forEach(listItem => {
						this.$set(listItem, 'checked', false);
					});
				}
			},
			// 删除check-box的选中
			deleteTHeadChecked(item, index) {
				let foundGroupIndex = -1;
				// 遍历每个分类
				this.tHeadAllList.forEach((category, categoryIndex) => {
					// 在当前分类的 list 中查找匹配的项
					const foundItem = category.list.find(items => items.label === item.label);
					if (foundItem) {
						this.$set(foundItem, 'checked', false);
						// 记录找到的分组索引
						foundGroupIndex = categoryIndex;
					}
				});
				this.tHeadCheckShowList.splice(index, 1);
			
				// 如果找到了对应的分组，更新该分组的状态
				if (foundGroupIndex !== -1) {
					this.updateGroupState(foundGroupIndex);
				}
			},
			handleDragStart(e, item) {
				this.dragging = item.label;
			},
			handleDragEnd(e, item) {
				this.dragging = null
			},
			//首先把div变成可以放置的元素，即重写dragenter/dragover
			handleDragOver(e) {
				e.dataTransfer.dropEffect = 'move' // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
			},
			handleDragEnter(e, item) {
				e.dataTransfer.effectAllowed = "move";
				// 如果拖拽目标是自身，则不处理
				if (item.label === this.dragging) {
					return;
				}
				try {
					const newItems = [...this.tHeadCheckShowList];
					// 查找源元素和目标元素的位置
					const src = newItems.findIndex(i => i.label === this.dragging);
					const dst = newItems.findIndex(i => i.label === item.label);
					// 验证索引有效性
					if (src === -1) {
						console.warn(`找不到源元素: ${this.dragging}`);
						return;
					}
					if (dst === -1) {
						console.warn(`找不到目标元素: ${item.label}`);
						return;
					}
					// 如果源和目标相同，不处理
					if (src === dst) {
						return;
					}
					// 移动元素
					const [movedItem] = newItems.splice(src, 1);
					newItems.splice(dst, 0, movedItem);
					this.tHeadCheckShowList = newItems;
				} catch (error) {
					console.error('拖拽操作出错:', error);
				}
			}
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}

	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
	}

	.el-form {}

	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}

	.tableTopBtn {
		margin-bottom: 16px;
		align-items: center;
	}

	.exportBtn {
		border: 1px solid #D9D9D9;
		box-sizing: border-box;
		align-items: center;
		height: 34px;
		width: 80px;
		font-size: 14px;
		color: #333;
		border-radius: 2px;
		cursor: pointer;
		margin-left: 15px;
	}

	.exportBtn img {
		width: 16px;
		height: 16px;
		margin-right: 4px;
	}

	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
	}

	.auditStatus {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.statusLabel {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin-right: 4px;
		background: #FA9600;
	}

	.menu-right {
		margin-left: auto;
	}

	.el_dialog_form /deep/ .el-form-item {
		margin-right: 0;
	}


	.businessLicenseTips {
		width: 120px;
		height: 120px;
		border-radius: 4px;
		border: 1px solid #DBDFE3;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.businessLicenseTips img {
		width: 56px;
		height: 56px;
	}

	.businessLicenseImg {
		width: 120px;
		height: 120px;
	}

	.selectTemp,
	.checkedTemp {
		align-items: center;
		width: 100%;
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}

	.selectTemp img,
	.checkedTemp img {
		width: 24px;
		height: 24px;
		margin-right: 4px;
	}

	.checkedTemp {
		height: 32px;
		margin-top: 4px;
	}
	
	
	.tHeadEditBox {
		border: 1px solid #C2CEDF;
		padding: 12px;
		box-sizing: border-box;
	}
	
	.tHeadAllList {
		width: 49%;
	}
	
	.checkList {
		width: 100%;
		flex-wrap: wrap;
		/* padding-right: 15px; */
		box-sizing: border-box;
	}
	
	.el_check_box {
		margin-bottom: 15px;
		margin-right: 0;
		width: 50%;
	}
	
	/deep/.el-collapse-item__header {
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}
	
	/deep/.el-collapse-item__content {
		padding-bottom: 10px;
	}
	
	.tHeadCheckShowBox {
		width: 49%;
		background: #F0F2F5;
		padding: 16px 18px;
		box-sizing: border-box;
	}
	
	.tHeadCheckShowTitle {
		font-size: 14px;
		color: #4E5865;
	}
	
	.tHeadCheckShowTips {
		font-size: 12px;
		color: #8E98AA;
	}
	
	.tHeadCheckShowList {
		border: 1px solid #C3CDE0;
		border-bottom: none;
		margin-top: 8px;
	}
	
	.tHeadCheckedOne {
		width: 100%;
		height: 34px;
		line-height: 34px;
		align-items: center;
		border-bottom: 1px solid #C3CDE0;
		padding: 0 8px;
		font-weight: 500;
		font-size: 14px;
		color: #4E5866;
		box-sizing: border-box;
		cursor: pointer;
	}
	
	.tHeadCheckedOne div {
		margin-left: 4px;
	}
	
	.tHeadCheckedOne img {
		width: 16px;
		height: 16px;
	}
	
	.tHeadCheckedOne i {
		font-size: 18px;
	}
	.tHeadFixedCheckList{
		flex-wrap: wrap;
		width: 40%;
	}
	.check-box-fixed{
		/* margin-bottom: 10px; */
	}
	
	/deep/.appNameIdOptions .el-select-dropdown__item {
		height: 48px !important;
		line-height: 48px !important;
	}
	
	.selectTemp2 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.selectAppName,
	.selectAppId {
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}
	
	.selectAppId {
		color: #999999;
		align-items: center;
	}
	
	.selectAppId img {
		width: 14px;
		height: 14px;
		margin-left: 3px;
	}
</style>
